import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Space, Row } from "@masterteam/mt-design-react";

import ProjectsList from "../../ProjectsList";

import { ReactComponent as ProjectsIcon } from "../../../assets/images/initiative-icon.svg";

import "./style.scss";

const ListsContainer = ({
  projectStatuses,
  initiative,
}) => {
  const [selectedSectors, setSelectedSectors] = useState([]);

  const tabs = [
    {
      ID: 1,
      name: "common.strategic-projects",
      value: "projects",
      icon: <ProjectsIcon />,
      showItem: true,
      component: () => (
        <ProjectsList
          projects={initiative?.Projects || []}
          projectStatuses={projectStatuses}
          isInitiatives
        />
      ),
    },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <Space direction="vertical" size="medium" className="animated slIDeInRight">
      <Row
        justify="between"
        align="center"
        className="strategic-kpis-container_header"
      >
        <Space gap={0}>
          {tabs
            .filter((e) => e.showItem)
            .map((item) => (
              <Space
                key={item.ID}
                onClick={() => {
                  setActiveTab(item);
                  setSelectedSectors([]);
                }}
                className={`tab-item cursor ${
                  activeTab.value === item.value && "active"
                }`}
              >
                {item.icon}
                <FormattedMessage id={item.name} />
              </Space>
            ))}
        </Space>

      </Row>

      {activeTab.component(selectedSectors)}
    </Space>
  );
};

export default ListsContainer;
